import { makeAutoObservable, toJS } from "mobx";
import {toast} from "react-toastify";
import Analytics, { EVENTS } from "../lib/Analytics";

class EChainStore {
  _appStatusStore = null;
  _isFetching = false;
  _fetchStartTime = null;
  _paths = [];
  _searchSessionStore = null;
  _targetID = "";
  _userStore = null;

  constructor(userData, appStatusStore, searchSessionStore) {
    makeAutoObservable(this);
    this._userStore = userData;
    this._appStatusStore = appStatusStore;
    this._searchSessionStore = searchSessionStore;
  }

  getEChains = async (targetID, datasetsFilter = []) => {
    this.isFetching = true;
    this._fetchStartTime = Date.now();
    try {
      const results = await this._searchSessionStore.fetchEvidenceChains(
        targetID,
        datasetsFilter,
        s => this._searchSessionStore.searchProgress = s
      );
      this.targetID = targetID;
      this.paths = results.paths || [];
      Analytics.event(EVENTS.ECHAINS_COMPLETE, {
        target_id: targetID,
        duration_ms: Date.now() - this._fetchStartTime,
        path_count: this.paths.length,
      });
    }
    catch (error) {
      const msg = `Error on receiving echain data: ${
            error.message || error.detail || error.statusText || "(no details)"
          }. targetId = ${targetID}`;
      toast.error(msg, {error: new Error(
          `Error on receiving echain data: ${
            error.message || error.detail || error.statusText || "(no details)"
          }. targetId = ${targetID}`
        )});
      Analytics.event(EVENTS.ECHAINS_ERROR, {
        target_id: targetID,
        duration_ms: Date.now() - this._fetchStartTime,
        error: error.message || error.detail || "(no details)",
      });
      this.paths = [];
      this.targetID = "";
      this.isFetching = false;
    }

    this.isFetching = false;
  };

  cancelFetch = () => {
    if (this._isFetching && this._fetchStartTime) {
      Analytics.event(EVENTS.ECHAINS_CANCEL, {
        target_id: this._targetID,
        duration_ms: Date.now() - this._fetchStartTime,
      });
    }
  };

  get isFetching() {
    return this._isFetching;
  }

  set isFetching(b) {
    this._isFetching = b;
  }

  get targetID() {
    return this._targetID;
  }

  set targetID(t) {
    this._targetID = t;
  }

  get searchParams() {
    return this._searchSessionStore.params;
  }

  get searchIDs() {
    return this.searchParams.searchIDs;
  }

  get directConnectionID() {
    return this.searchParams.directConnectionID;
  }

  get neighborhood() {
    return this.searchParams.neighborhood;
  }

  get simThreshold() {
    return this.searchParams.simThreshold;
  }

  get simFloor() {
    return this.searchParams.simFloor;
  }

  get dsConfig() {
    return this.searchParams.dsConfig;
  }

  get paths() {
    return toJS(this._paths);
  }

  set paths(p) {
    this._paths = p;
  }

}

export default EChainStore;
